export default __webpack_public_path__ + "static/media/planeTurbineMobile.24927d6a.png";